import { EChartPoint } from './types';

const closestPointRange = (data: EChartPoint[]): number => {
    let closest = Infinity;
    for (let index = 1; index < data.length; index++) {
        const distance = data[index][0] - data[index - 1][0];
        if (distance > 0 && distance < closest) {
            closest = distance;
        }
    }
    return closest;
};

export const fillGaps = (data: EChartPoint[], stepMs: number, gapSize: number = 2): EChartPoint[] => {
    if (data.length < 2 || !stepMs || stepMs <= 0) {
        return data.slice();
    }

    const range = closestPointRange(data);
    const step = Number.isFinite(range) && range > 0 ? range : stepMs;
    const threshold = gapSize * step;
    const filled: EChartPoint[] = [data[0]];

    for (let index = 1; index < data.length; index++) {
        const previous = data[index - 1];
        const current = data[index];
        if (current[0] - previous[0] > threshold) {
            filled.push([previous[0] + step, null]);
        }
        filled.push(current);
    }

    return filled;
};
